import { TabItem } from '../../models/common/tab-items';
import { AgentService } from '../services/agent.service';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageHeader } from '../../models/common/page-header';
import { StepItem } from 'src/app/models/common/step-item';
import { BaseStepFormComponent } from 'src/app/system-common/base-step-form/base-step-form.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { Location } from '@angular/common';
import { ResponseIO } from 'src/app/models/responseIO';
import { NavigationLink } from 'src/app/models/common/navigation-link';
declare const showSpinner: any;
declare const hideSpinner: any;

@Component({
  selector: '',
  template: '',
})
export class AgentRecruitmentStepFormHandlerComponent
  extends BaseStepFormComponent<AgentService>
  implements OnInit
{
  navigationLinkList: NavigationLink[];
  isTriggerOtpBtn: boolean;
  message: { isSuccess: boolean; text: string };
  buttonClicked: string;
  sendlinkOk: boolean;
  transferClick: boolean;
  revokeClick: boolean;
  continueClick: boolean;
  exportHide: boolean = true;
  isPaymentReq: string;
  public agentId;
  public searchText;
  public arrvalidationerrors = [];
  public applicationProperties;
  public isValidOtptyped: boolean;
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
    this.isTriggerOtpBtn = false;
    this.service.isAuditButtonClicked = false;
    this.arrvalidationerrors = [];
    this.applicationProperties = JSON.parse(this.settingService.getSessionStorageValue('applicationProperties'));
  }

  ngOnInit(): void {
    this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.service.userType = this.settingService.getSessionStorageValue('userType');
    if (sessionStorage.getItem('applicationProperties') != undefined)
      this.isPaymentReq = JSON.parse(sessionStorage.getItem('applicationProperties'))['PAYMENTREQUIREDFL'];
    this.setNavigationLinks();
    super.ngOnInit();
    this.arrvalidationerrors = [];
  }
  protected getStepList(): StepItem[] {
    return this.getCustomStepList();
  }
  protected getCustomStepList(): StepItem[] {
    let customStepList: StepItem[] = this.getInitialStepList();
    if (
      this.service &&
      this.service.responseIO &&
      this.service.responseIO.data &&
      this.service.responseIO.data.Entity &&
      this.service.responseIO.data.Entity.applicationStatusCd != undefined &&
      this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED'
    ) {
      customStepList = [];
      let step1 = new StepItem(
        0,
        'step_reviewApp',
        [
          {
            id: 'tab_reviewApp',
            modelList: [
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
              'NomineeList',
              'LicenseList',
              'QuestionList',
              'ReferenceList',
              'FamilyList',
            ],
          },
        ]
        //  ['Export']
      );
      customStepList.push(step1);
    } else {
      customStepList = this.getInitialStepList();
    }
    return customStepList;
  }

  protected getInitialStepList(): StepItem[] {
    let stepList: StepItem[] = [
      new StepItem(
        0,
        'step_register',
        [
          {
            id: 'tab_basic',
            modelList: [
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
            ],
          },
        ],
        ['but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        1,
        'step_completeDataEntry',
        [
          { id: 'tab_Hierarchy', modelList: ['AgentDetail', 'Supervisor', 'Branch'] },
          { id: 'tab_education', modelList: ['AgentParty', 'EducationList', 'PartyEmployment'] },
          // { id: 'tab_training', modelList: ['TrainingList'] },
          { id: 'tab_bankdetails', modelList: ['AgentParty', 'PaymentList'] },
          // { id: 'tab_exam', modelList: ['ExamList'] },
          { id: 'tab_existingAgency', modelList: ['AgentDetail', 'LicenseList'] },
          { id: 'tab_Nominee', modelList: ['NomineeList'] },
          { id: 'tab_questions', modelList: ['QuestionList'] },
          { id: 'tab_family', modelList: ['FamilyList'] },
          // { id: 'tab_reference', modelList: ['ReferenceList'] },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        2,
        'step_requirement',
        [
          {
            id: 'tab_requirement',
            modelList: [
              'AgentParty',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'DocumentCategoryDOList',
              'DocumentCategoryMapDOList',
            ],
          },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        3,
        'step_signature',
        [
          {
            id: 'tab_signature',
            modelList: ['AgentParty', 'ServiceSignatureList'],
          },
        ],
        ['but_Back', 'but_DraftSave', 'but_Continue']
      ),
      new StepItem(
        4,
        'step_reviewApp',
        [
          {
            id: 'tab_reviewApp',
            modelList: [
              'AgentParty',
              'AgentDetail',
              'RelativesList',
              'PaymentList',
              'EducationList',
              'TrainingList',
              'ExamList',
              'DocumentCategoryList',
              'DocumentList',
              'DocumentImageList',
              'PartyOccupation',
              'NotesModel',
              'ServiceSignatureList',
              'NomineeList',
              'LicenseList',
              'QuestionList',
              'ReferenceList',
              'FamilyList',
            ],
          },
        ]
        //  ['Export']
      ),
      new StepItem(
        5,
        'step_payment',
        [
          {
            id: 'tab_payment',
            modelList: ['AgentParty', 'AgentDetail'],
          },
        ],
        ['but_Back']
      ),
    ];

    if (this.isPaymentReq == 'NO') stepList.pop();
    return stepList;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // console.log(this.service.responseIO.data);
    header.refNumber = this.service.responseIO.data.Entity.applicationNum;
    header.title = this.settingService.getLabelValue('agent');
    header.moreOptionList = this.getMoreOptionList();
    return header;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    // let isMenuSelected = this.service.getSessionStorageValue('isMenuSelected');
    if (this.service.getSessionStorageValue('isMenuSelected') == 'true') {
      return [
        {
          id: 'home',
          link: '/home',
        },
        {
          id: 'search',
          link: '/agent-search',
        },
        {
          id: 'agent',
        },
      ];
    }
  }

  protected getMoreOptionList(): any[] {
    // if (this.service.getSessionStorageValue('isMenuSelected') == 'true') {
    return [
      {
        id: 'Audit',
        link: '/audit-search/:id',
      },
    ];
    // }
  }

  // clickedAuditEvent(data) {
  //   this.service.isAuditButtonClicked = data;
  // }

  public Audit_click(clickedButton: { id: string; link: string }) {
    setTimeout(() => {
      this.openModal('agentAuditPopUp');
      this.service.isAuditButtonClicked = true;
    }, 10);
  }

  closeAgentAuditPopUp() {
    this.closeModal('agentAuditPopUp');
    // this.service.isAuditButtonClicked = false;
  }

  public Notes_click(clickedButton: { id: string; link: string }) {
    $('#addNote').show();
  }

  protected but_Submit_click() {
    //setting the current step itself as the next step since is the last step
    this.isTriggerOtpBtn = true;
    this.buttonClicked = 'but_Submit';
    // setTimeout(() => {
    //   $('#otpPopup').show();
    // }, 10);
  }

  //Override the on save method and write custom logic  for accept only
  // protected onSaveUpdatedModels(
  //   body: any,
  //   currentStepObj: StepItem,
  //   nextStepObj?: StepItem,
  //   nextTabObj?: TabItem,
  //   buttonId?: string
  // ) {
  //   super.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
  //   if (
  //     this.selectedStep.id == 'step_reviewApp' &&
  //     buttonId == 'but_Submit' &&
  //     (this.selectedStep.errorCount == 0 || this.selectedStep.errorCount == undefined)
  //   ) {
  //     showSpinner();
  //     this.service.responseIO.data.Entity.step = 6;
  //     this.agentSubmit();
  //   }
  //   this.preStepSelection(this.selectedStep);
  // }

  private setNavigationLinks() {
    this.navigationLinkList = [];
    // this.service.responseIO.data.DocumentCategoryList.filter((documentCategory) => {
    //   let nav = new NavigationLink();
    //   nav.link = documentCategory.docCategoryCd;
    //   nav.labelKey = this.service.getFieldLookupDesc(documentCategory, 'docCategoryCd');
    //   this.navigationLinkList.push(nav);
    // });
  }

  agentSubmit() {
    this.service.responseIO.data.Entity.stepActionTabs = undefined;
    this.service.submitAgent().subscribe(
      (successResponse) => {
        if (successResponse['success'] == true) {
          this.service.responseIO = new ResponseIO();
          this.service.responseIO = JSON.parse(JSON.stringify(successResponse));
          let serviceResponse = this.service.responseIO;
          this.agentSubmissionMessages(this.buttonClicked, successResponse);
          this.headerService.pageHeader = this.getPageHeader();
        } else {
          this.agentSubmissionMessages(this.buttonClicked, successResponse);
        }
      },
      (error) => {
        console.log('Agent submit failed.');
        console.log('Error:', error);
      }
    );
  }

  agentSubmissionMessages(buttonClicked, successResponse) {
    this.service.responseIO = new ResponseIO();
    this.service.responseIO = JSON.parse(JSON.stringify(successResponse));
    if (
      SettingService.getApplicationPropertiesValue('PAYMENTREQUIREDFL') != undefined &&
      SettingService.getApplicationPropertiesValue('PAYMENTREQUIREDFL') == 'NO' &&
      SettingService.getApplicationPropertiesValue('CHECKERFLOWREQD') != undefined &&
      SettingService.getApplicationPropertiesValue('CHECKERFLOWREQD') == 'NO'
    ) {
      if (this.selectedStep.id == 'step_reviewApp' && successResponse.validationerrors == undefined) {
        this.stepList['buttonList'] = [];
        this.message = {
          isSuccess: true,
          text: 'Agent has been synced with DMS',
        };
        this.service.responseIO.data.Entity.intfStatusCd = null;
        this.openModal(`submitAgentModal`);
      } else if (this.selectedStep.id == 'step_reviewApp' && successResponse.validationerrors != undefined) {
        this.onViewErrorClick();
      }
    } else {
      if (this.selectedStep.id == 'step_reviewApp' && this.buttonClicked == 'but_Continue') {
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentSubmitMesg'),
        };
      } else if (this.buttonClicked == 'but_transfer') {
        if (this.service.responseIO.data.Entity.applicationStatusCd == 'REMOTE') {
          this.message = {
            isSuccess: successResponse['success'],
            text: this.service.getMultilingualLabel('agentTransferMessage'),
          };
          this.stepList[0]['buttonList'] = ['but_revoke', 'but_resend'];
        } else if (this.service.responseIO.data.Entity.applicationStatusCd == 'PENDING') {
          this.message = {
            isSuccess: successResponse['success'],
            text: this.service.getMultilingualLabel('agentTransferFailMessage'),
          };
        }

        this.openModal(`submitAgentModal`);
      } else if (this.buttonClicked == 'but_revoke') {
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentRevokeMessage'),
        };
        // this.stepList[0]['buttonList'] = [];
        this.openModal(`submitAgentModal`);
      } else if (this.selectedStep.id == 'step_payment' && this.buttonClicked == 'but_Continue') {
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentSubmitMesg'),
        };
      } else if (
        this.service.responseIO.data.AgentDetail.receiptStatusCd == 'COMPLETED' &&
        this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED'
      ) {
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentSubmitMesg'),
        };
      } else {
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentTransferBackMessage'),
        };
        this.stepList['buttonList'] = [];
        this.openModal(`submitAgentModal`);
      }
    }
    //this.openModal(`submitAgentModal`);
  }

  closeSubmitAgentModal() {
    this.closeModal(`submitAgentModal`);
    this.selectedStep.buttonList = [];
    this.service.reloadCurrentRoute();
  }

  but_transfer_click() {
    this.buttonClicked = 'but_transfer';
    const { Entity, AgentDetail, AgentParty } = this.service.responseIO.data;
    Entity.applicationStatusCd = 'REMOTE';

    const isValidAgentDetail = AgentDetail?.intermedSubCatCd != null && AgentDetail.intermedSubCatCd.trim() !== '';
    const isValidContactNum =
      AgentParty?.MobileContact?.contactNum != null && AgentParty.MobileContact.contactNum.trim() !== '';
    const isValidEmail =
      AgentParty?.PersonalEmail?.emailAddress != null && AgentParty.PersonalEmail.emailAddress.trim() !== '';

    if (this.selectedStep.id === 'step_register') {
      if (isValidAgentDetail && isValidContactNum && isValidEmail && Entity.applicationNum != null) {
        this.agentSubmit();
      } else {
        Entity.applicationStatusCd = 'PENDING';
        const enterText = this.findMissingFields(isValidAgentDetail, isValidContactNum, isValidEmail);
        this.error(`Kindly enter ${enterText}`);
        this.saveUpdatedModels(this.selectedStep, this.stepList[this.selectedStep.index]);
        hideSpinner();
      }
    } else {
      this.agentSubmit();
    }
  }

  findMissingFields(isValidAgentDetail, isValidContactNum, isValidEmail) {
    if (isValidAgentDetail) {
      if (isValidContactNum) {
        return 'Email Id';
      } else if (isValidEmail) {
        return 'Phone Number';
      } else {
        return 'Phone Number and Email Id';
      }
    } else if (isValidContactNum) {
      if (isValidEmail) {
        return 'Agent Category';
      } else {
        return 'Email Id and Agent Category';
      }
    } else if (isValidEmail) {
      return 'Phone Number and Agent Category';
    } else {
      return 'Phone Number, Email Id and Agent Category';
    }
  }

  but_revoke_click() {
    this.buttonClicked = 'but_revoke';
    this.service.responseIO.data.Entity.applicationStatusCd = 'PENDING';
    // this.service.responseIO.data.AgentDetail.applicationStatusCd = 'PENDING';
    setTimeout(() => {
      showSpinner();
    }, 5);
    this.agentSubmit();
    //this.saveUpdatedModels(this.selectedStep, this.selectedStep, undefined, 'but_Submit');
  }

  but_transferBack_click() {
    this.transferClick = false;
    this.revokeClick = false;
    this.buttonClicked = 'but_transferBack';
    this.service.responseIO.data.Entity.applicationStatusCd = 'PENDING';
    // this.service.responseIO.data.AgentDetail.applicationStatusCd = 'PENDING';

    this.sendlinkOk = false;
    setTimeout(() => {
      showSpinner();
    }, 5);
    this.agentSubmit();
  }

  getPDFContnet(pdfObject) {
    // console.log(pdfObject);
    const byteArray = new Uint8Array(
      atob(pdfObject)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    // use this blob object for further use
    const source = `data:application/pdf;base64,${pdfObject}`;
    // console.log(source);
    const link = document.createElement('a');
    link.href = source;
    link.download = this.service.responseIO.data.Entity.applicationNum + '_ApplicationForm.pdf';
    // console.log(link.download);
    link.click();
  }

  btn_export_click() {
    let documentImageArray = [];
    // Commented the code For Export click on review appliation form. - By Snehal
    /*for (let documentCategory of this.service.responseIO.data.DocumentCategoryList) {
      for (let i = 0; i < documentCategory.DocumentList.length; i++) {
        if (documentCategory.DocumentList[i].DocumentImageList.length > 0) {
          documentImageArray.push(documentCategory.DocumentList[i]);
          if (documentCategory.DocumentList[i].documentCd == 'APPLICATIONFORM') {
            for (let documentImage of documentCategory.DocumentList[documentImageArray.length - 1][
              'DocumentImageList'
            ]) {
              this.getPDFContnet(documentImage['fileContents']);
              //  this.downloadPDF(documentImage['fileContents'])
            }
            break;
          }
        }
      }
    }*/
    this.service.hideLoader(true);
  }

  protected preStepSelection(nextStepObj: StepItem): void {
    //for all steps if status is Accepted then remove the buttons
    if (this.service.responseIO.data.Entity.isCompleted || this.service.responseIO.data.Entity.isInvalid) {
      if (this.service.responseIO.data.Entity.applicationStatusCd == 'REMOTE') {
        nextStepObj.buttonList = ['but_revoke', 'but_resend'];
      } else if (
        this.service.responseIO.data.Entity.applicationStatusCd == 'SUBMITTED' &&
        nextStepObj.id === 'step_reviewApp'
      ) {
        if (this.isPaymentReq != undefined && this.isPaymentReq == 'NO') {
          nextStepObj.buttonList = [];
        }
        // nextStepObj.buttonList = ['btn_export'];
        //Commented By Snehal - if we add the application stepForm it will add the Export button.
        /*
        let documentImageArray = [];
        for (let documentCategory of this.service.responseIO.data.DocumentCategoryList) {
          for (let i = 0; i < documentCategory.DocumentList.length; i++) {
            if (documentCategory.DocumentList[i].DocumentImageList.length > 0) {
              documentImageArray.push(documentCategory.DocumentList[i]);
              // console.log("Array push",documentImageArray)
              if (documentCategory.DocumentList[i].documentCd == 'APPLICATIONFORM') {
                for (let documentImage of documentCategory.DocumentList[documentImageArray.length - 1][
                  'DocumentImageList'
                ]) {
                  if (documentImage['fileContents'] != null) {
                    nextStepObj.buttonList = ['btn_export'];
                  }
                }
                break;
              }
            }
          }
        }*/
      } else if (
        nextStepObj.id == 'step_payment' &&
        this.service.responseIO.data.Entity.applicationStatusCd == 'PENDINGPAYMENT'
      ) {
        nextStepObj.buttonList = ['but_Back'];
      } else {
        nextStepObj.buttonList = [];
      }
    } else if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'PENDING' &&
      nextStepObj.id == 'step_register'
    ) {
      if (this.settingService.getSessionStorageValue('userType') == 'RECRUITEE') nextStepObj.buttonList = [];
      else nextStepObj.buttonList = ['but_DraftSave', 'but_transfer', 'but_Continue'];
    } else if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'PENDING' &&
      this.settingService.getSessionStorageValue('userType') == 'RECRUITEE'
    ) {
      nextStepObj.buttonList = [];
    } else if (this.service.responseIO.data.Entity.applicationStatusCd == 'REMOTE') {
      let isMenuSelected = this.service.getSessionStorageValue('isMenuSelected');
      if (this.settingService.getSessionStorageValue('userType') == 'RECRUITEE') {
        nextStepObj.buttonList =
          this.service.responseIO.data.Entity.applicationStatusCd != null
            ? ['but_DraftSave', 'but_transferBack', 'but_Continue']
            : ['but_DraftSave', 'but_Continue'];
      } else if (this.settingService.getSessionStorageValue('userType') == 'MAKER-INTERNAL') {
        nextStepObj.buttonList = ['but_revoke', 'but_resend'];
      }
    } else if (
      this.service.responseIO.data.Entity.applicationStatusCd == 'PENDING' &&
      this.settingService.getSessionStorageValue('userType') == 'RECRUITEE'
    ) {
      nextStepObj.buttonList = [];
    } else if (
      nextStepObj.id == 'step_payment' &&
      this.service.responseIO.data.Entity.applicationStatusCd == 'PENDINGPAYMENT'
    ) {
      nextStepObj.buttonList = [];
    } else {
      if (
        this.service.responseIO.data.Entity.applicationStatusCd != undefined &&
        this.service.responseIO.data.Entity.applicationStatusCd != 'COMPLETED' &&
        this.service.responseIO.data.Entity.applicationStatusCd != 'PENDINGPAYMENT'
      )
        nextStepObj.buttonList = ['but_DraftSave', 'but_transfer', 'but_Continue'];
      else if (
        this.service.responseIO.data.Entity.applicationStatusCd != undefined &&
        (this.service.responseIO.data.Entity.applicationStatusCd != 'COMPLETED' ||
          this.service.responseIO.data.Entity.applicationStatusCd == 'PENDINGPAYMENT')
      )
        nextStepObj.buttonList = ['but_DraftSave', 'but_Continue'];
      else if (
        this.service.responseIO.data.Entity.applicationStatusCd != undefined &&
        this.service.responseIO.data.Entity.applicationStatusCd == 'COMPLETED' &&
        nextStepObj.id === 'step_reviewApp'
      )
        nextStepObj.buttonList = [];
    }
  }

  protected preProcess(): boolean {
    let shouldSave: boolean = true;
    //As summary tab is readonly there is no need to save but just load the next tab while moving
    //out of this tab

    if (this.service.responseIO.data.Entity.isCompleted || this.service.responseIO.data.Entity.isInvalid) {
      //submitted cases should not be edited and saved just viewed hence return false
      shouldSave = false;
    }
    return shouldSave;
  }

  public onValidateOtp(isValidOtp: boolean) {
    this.isValidOtptyped = isValidOtp;
    this.isTriggerOtpBtn = false;
    this.service.userType = this.settingService.getSessionStorageValue('userType');
    if (
      isValidOtp &&
      this.selectedStep.id === 'step_reviewApp' &&
      this.service.responseIO.data.AgentDetail.receiptStatusCd != 'COMPLETED' &&
      this.isPaymentReq == 'YES'
    ) {
      let nextStepObj = this.stepList[this.selectedStep.index + 1];
      // this.saveUpdatedModels(this.selectedStep, nextStepObj);
      this.service.responseIO.data.Entity.applicationStatusCd = 'PENDINGPAYMENT';
      this.service.responseIO.data.AgentDetail.receiptStatusCd = 'PENDING';
      this.saveUpdatedModels(this.selectedStep, nextStepObj, undefined, 'but_Submit');
      this.stepList[4]['buttonList'] = [];
      setTimeout(() => {
        showSpinner();
      }, 5);
    } else if (
      this.service.responseIO.data.AgentDetail.receiptStatusCd == 'COMPLETED' ||
      this.isPaymentReq == 'NO'
    ) {
      if (!isValidOtp) {
        return;
      } else {
        let nextStepObj = this.stepList[this.selectedStep.index];
        this.service.responseIO.data.Entity.applicationStatusCd = 'SUBMITTED';
        this.service.responseIO.data.AgentDetail.receiptStatusCd = 'COMPLETED';
        this.saveUpdatedModels(this.selectedStep, nextStepObj, undefined, 'but_Submit');
        this.stepList[4]['buttonList'] = [];
        setTimeout(() => {
          showSpinner();
        }, 5);
      }
    }
  }

  but_resend_click() {
    this.buttonClicked = 'but_transfer';
    this.service.responseIO.data.Entity.applicationStatusCd = 'REMOTE';
    // this.stepList[3]['buttonList'] = [];
    setTimeout(() => {
      showSpinner();
    }, 5);
    // this.agentSubmit();
    let applicationNum = this.service.responseIO.data.Entity.applicationNum;
    this.service.sendEmail(applicationNum).subscribe(
      (successResponse) => {
        console.log('response', successResponse);
        this.message = {
          isSuccess: successResponse['success'],
          text: this.service.getMultilingualLabel('agentTransferMessage'),
        };
        this.openModal(`submitAgentModal`);
      },
      (error) => {
        console.log('Error:', error);
      }
    );
    //this.saveUpdatedModels(this.selectedStep, this.selectedStep, undefined, 'but_Submit');
  }

  protected but_Continue_click() {
    this.buttonClicked = 'but_Continue';
    this.sendlinkOk = false;
    this.transferClick = false;
    this.revokeClick = false;
    //this.buttonClicked = 'but_Continue';
    console.log('this.selectedStep-- ' + this.selectedStep?.id);
    console.log('Entity.applicationStatusCd-- ' + this.service.responseIO.data.Entity.applicationStatusCd);
    console.log('Is Equal step:', this.selectedStep?.id === 'step_reviewApp');
    console.log(
      'Is Equal applicationStatusCd:',
      this.service.responseIO.data.Entity.applicationStatusCd === 'PENDINGPAYMENT'
    );
    if (
      this.selectedStep.id === 'step_reviewApp' &&
      (this.service.responseIO.data.Entity.applicationStatusCd === 'PENDING' ||
        this.service.responseIO.data.Entity.applicationStatusCd === 'REQUIREMENT' ||
        this.service.responseIO.data.Entity.applicationStatusCd === 'REMOTE' ||
        this.service.responseIO.data.Entity.applicationStatusCd === 'PENDINGPAYMENT')
    ) {
      this.continueClick = true;
      this.isTriggerOtpBtn = true;
    } else {
      super.but_Continue_click();
    }
  }

  onAddNote() {
    $('#addNote').show();
  }

  protected but_Back_click(): void {
    super.but_Back_click();
    if (this.selectedStep != undefined && this.selectedStep.id == 'step_payment') {
      this.stepList[3]['buttonList'] = ['but_Back', 'but_Continue'];
    }
  }

  // changeButtonManual() {
  //   if (
  //     this.service.responseIO != undefined &&
  //     this.service.responseIO.data.Entity.applicationStatusCd == 'REMOTE'
  //   ) {
  //     this.stepList[3]['buttonList'] = ['but_revoke', 'but_resend'];
  //   } else if (
  //     this.service.responseIO != undefined &&
  //     this.service.responseIO.data.Entity.applicationStatusCd == 'PENDINGPAYMENT'
  //   ) {
  //     this.stepList[3]['buttonList'] = ['but_Back', 'but_Continue'];
  //   } else {
  //     this.stepList[3]['buttonList'] = ['but_Back', 'but_transfer', 'but_Continue'];
  //   }
  // }

  protected setCustomStepStatus(stepItem: StepItem): void {
    if (stepItem.index <= this.service.responseIO.data.Entity.step) stepItem.status = 'completed';
    else if (stepItem.index > this.service.responseIO.data.Entity.step) stepItem.status = 'pending';
  }

  public showErrorMessage() {
    this.arrvalidationerrors = [];
    if (
      this.service != undefined &&
      this.service.responseIO != undefined &&
      this.service.responseIO.validationerrors != undefined
    ) {
      Object.keys(this.service.responseIO.validationerrors).forEach((element1) => {
        Object.keys(this.service.responseIO.validationerrors[element1]).forEach((element2) => {
          Object.keys(this.service.responseIO.validationerrors[element1][element2]).forEach((element) => {
            let str = this.service.responseIO.validationerrors[element1][element2][element];
            let strlen = (str.match(/;/g) || []).length;
            if (strlen > 0) {
              for (let i = 0; i < strlen; i++) {
                let validationerror = str.split(';')[i];
                this.arrvalidationerrors.push(validationerror);
              }
            } else {
              this.arrvalidationerrors.push(this.service.responseIO.validationerrors[element1][element2][element]);
            }
          });
        });
      });
    }
  }

  /**
   * This open the Error modal
   */
  onViewErrorClick() {
    this.showErrorMessage();
    this.openModal('errorModal');
  }
  /**
   * This close the Error modal
   */
  closeErrorModal() {
    this.closeModal('errorModal');
  }

  protected async onSaveUpdatedModels(
    body: any,
    currentStepObj: StepItem,
    nextStepObj?: StepItem,
    nextTabObj?: TabItem,
    buttonId?: string
  ) {
    super.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
    this.preStepSelection(this.selectedStep);
  }

  protected saveUpdatedModels(
    currentStepObj: StepItem,
    nextStepObj?: StepItem,
    nextTabObj?: TabItem,
    buttonId?: string
  ) {
    let service = this.altService != undefined ? this.altService : this.service;
    let modelNameList;
    if (nextTabObj != undefined && nextTabObj != null) {
      modelNameList = nextTabObj.modelList;
    } else {
      modelNameList =
        currentStepObj.selectedTab == undefined
          ? currentStepObj.tabList[0].modelList
          : currentStepObj.selectedTab.modelList;
    }

    let modelNameBodyList = this.getModelNameBodyList(modelNameList);
    this.setVisitedTabs();
    if (
      nextStepObj != null &&
      (nextStepObj.index != currentStepObj.index || nextStepObj.index == this.stepList.length - 1)
    ) {
      this.setStepActionTab(currentStepObj);
    }
    this.responseUpdated = false;
    this.isDataSaved = false;

    if (nextTabObj != null) service.currentActiveTab = nextTabObj.id;
    else if (currentStepObj != null && currentStepObj.selectedTab != null)
      service.currentActiveTab = currentStepObj.selectedTab.id;
    service.currentActiveField = undefined;
    service.process(service.id, modelNameBodyList).subscribe(
      async (body) => {
        await this.onSaveUpdatedModels(body, currentStepObj, nextStepObj, nextTabObj, buttonId);
        console.log('isValidOtptyped', this.isValidOtptyped);
        if (this.selectedStep.id == 'step_reviewApp' && buttonId == 'but_Submit' && this.isValidOtptyped) {
          this.service.responseIO.data.Entity.stepActionTabs = undefined;
          await this.service.submitAgent().subscribe(
            (successResponse) => {
              if (successResponse['success'] == true) {
                this.service.responseIO = new ResponseIO();
                this.service.responseIO = JSON.parse(JSON.stringify(successResponse));
                this.isDataSaved = true;
                this.agentSubmissionMessages(this.buttonClicked, successResponse);
                this.headerService.pageHeader = this.getPageHeader();
              } else {
                this.isDataSaved = true;
                this.agentSubmissionMessages(this.buttonClicked, successResponse);
              }
            },
            (error) => {
              console.log('Agent submit failed.');
              console.log('Error:', error);
            }
          );
        }
      },
      (error) => {
        console.log('Data updated failed.');
        console.log('Error:', error);
      }
    );
  }
}
